
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, Form } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Users } from "lucide-react";
import { FormValues } from "./types";
import { useTranslation } from "react-i18next";

interface GroupBookingProps {
  form: UseFormReturn<FormValues>;
  isGroupBooking: boolean;
  groupSize: number;
  groupNameInputs: string[];
  updateGroupName: (index: number, value: string) => void;
}

export const GroupBookingSection: React.FC<GroupBookingProps> = ({
  form,
  isGroupBooking,
  groupSize,
  groupNameInputs,
  updateGroupName,
}) => {
  const { t } = useTranslation();

  return (
    <Form {...form}>
      <div className="flex items-center justify-between p-3 border border-border rounded-md">
        <div className="flex items-center gap-2">
          <Users size={18} />
          <div className="space-y-1 leading-none">
            <span className="font-medium">{t('booking.group.title')}</span>
            <p className="text-xs text-muted-foreground">
              {t('booking.group.subtitle')}
            </p>
          </div>
        </div>
        <FormField
          control={form.control}
          name="isGroupBooking"
          render={({ field }) => (
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          )}
        />
      </div>
            
      {isGroupBooking && (
        <div className="space-y-4 pt-2 px-3">
          <FormField
            control={form.control}
            name="groupSize"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('booking.group.peopleCount')}</FormLabel>
                <FormControl>
                  <Select 
                    onValueChange={(value) => field.onChange(parseInt(value))} 
                    value={field.value.toString()}
                  >
                    <FormControl>
                      <SelectTrigger>
                        <SelectValue placeholder={t('booking.group.selectSize')} />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent>
                      {[2, 3, 4, 5, 6, 7, 8, 9, 10].map(size => (
                        <SelectItem key={size} value={size.toString()}>
                          {size} {t('booking.group.people')}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
                
          {groupNameInputs.length > 0 && (
            <div>
              <FormLabel className="block mb-2">{t('booking.group.otherNames')}</FormLabel>
              <div className="space-y-2">
                {groupNameInputs.map((name, index) => (
                  <Input
                    key={index}
                    placeholder={t('booking.group.attendeeName', { number: index + 2 })}
                    value={name}
                    onChange={(e) => updateGroupName(index, e.target.value)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </Form>
  );
};
